import { StopOutlined } from "@ant-design/icons";
import { Typography, Empty } from "antd";
import { useTranslation } from "react-i18next";

import InterventionsTable from "@/components/ListTable/InterventionsTable";
import { ObservationItem } from "@/components/Observation/Observation.type";
import {
  LIST_TABLE_HEADER_MIN_HEIGHT,
  LIST_TABLE_ROW_MIN_HEIGHT,
} from "@/constants/Layout";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import {
  INTERVENTIONS_FILTERS,
  INTERVENTIONS_INCLUDES,
  INTERVENTIONS_SORTS,
} from "@/entities/interventions";
import { ListProvider } from "@/modules/list";

const { Title } = Typography;

// Show 3 rows max (before scroll)
const TABLE_MAX_HEIGHT =
  LIST_TABLE_HEADER_MIN_HEIGHT + 3 * LIST_TABLE_ROW_MIN_HEIGHT;

const ObservationRecommendedInterventionsTable = ({ observation }) => {
  const recommendationId = observation.recommendation?.id;
  const enabled = recommendationId ? true : false;
  const { t } = useTranslation();

  return (
    <div className="observation-recommended-interventions-table">
      <Title level={4}>{t("observation:recommendedInterventions.title")}</Title>
      <ListProvider
        endpoint="interventions"
        storageKey={STORAGE_KEYS.OBSERVATIONS_RECOMMENDATIONS}
        enabled={enabled}
        hiddenFilters={{
          [[INTERVENTIONS_FILTERS.RECOMMENDATION_ID]]: recommendationId,
        }}
        includes={[INTERVENTIONS_INCLUDES.USERS]}
        defaultSort={[INTERVENTIONS_SORTS.SCHEDULED_DATE_DESC]}
        lazy={{ scrollY: { maxHeight: TABLE_MAX_HEIGHT } }}
      >
        {observation.needs_recommendation ? (
          <InterventionsTable
            showExportButton={false}
            showBatchMode={false}
            showActionsButtons={false}
            fixedColumns={false}
            hiddenColumns={[
              "scheduling_state",
              "intervention_template_id",
              "progress",
              "users.id",
              "updated_at",
            ]}
          />
        ) : (
          <div className="recommendation-card-content-center -empty">
            <Empty
              description={t("recommendation:noRecommendations.active")}
              image={<StopOutlined />}
              className="no-recommendations-infos"
            />
          </div>
        )}
      </ListProvider>
    </div>
  );
};

ObservationRecommendedInterventionsTable.propTypes = {
  observation: ObservationItem,
};

export default ObservationRecommendedInterventionsTable;
